export declare const server: (serv: Server, settings: Options) => void;
export declare const player: (player: Player, serv: Server) => void;
declare global {
    interface Server {
        /** Ban player given a uuid. If the player is online, using `player.ban()`. Bans with reason or `You are banned!`. */
        "ban": (uuid: string, reason?: string) => Promise<boolean>;
        /** Gets UUID from username. Since it needs to fetch from mojang servers, it is not immediate.
         *
         * Arguments in format: `callback(uuid)`. `uuid` is null if no such username exists.
         */
        'getUUIDFromUsername': (username: string) => Promise<string>;
        /** Bans players given a username. Mainly used if player is not online, otherwise use `player.ban()`. */
        "banUsername": (username: string, reason: string) => Promise<boolean>;
        /** Pardons a player given a username. */
        "pardonUsername": (username: string) => Promise<boolean>;
        /**
         * Object of players that are banned, key is their uuid. Use {@link getUUIDFromUsername() `getUUIDFromUsername()`} if you only have their username.
         *
         * Example player:
         * ```
         * {
         *     time: <time in epoch>,
         *     reason: <reason given>
         * }
         * ```
         */
        'bannedPlayers': {};
    }
    interface Player {
        /** kicks player with `reason` */
        "kick": (reason?: string) => void;
    }
}
